import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import VenueForm from "../VenueForm";

import { useVenueAddForm } from "./hooks";

const VenueAdd: React.FC = () => {
  const form = useVenueAddForm();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Create a new Venue" />
        </Typography.Title>
      </Header>
      <Space />
      <VenueForm {...form} autodetectTimezone />
    </>
  );
};

export default VenueAdd;
